import { useContext, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useQuery } from "@apollo/client"
import _ from "lodash"
import { DateTime } from "luxon"

import {
  GET_MAX_SERVICE_EPISODE,
  GET_PAST_SERVICE_EPISODE,
  GET_PAST_SERVICE_EPISODE_SUMMARIZED,
} from "./queries"
import GLOBALS_STATUS from "../../config/globalsStatus"
import { UserContext } from "../../context/userContext"

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"

// Comps
import LoaderFullPage from "../../components/Loaders"
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import ParticipantProfileBoxSmall from "../../components/ParticipantProfileBoxSmall"

import styles from "../../styles/Page-Engagements.module.css"
import { navigateWithOrigin } from "../../helpers/navigation"

export default function ServicesEpisodes() {
  const [maxServiceEpisodes, setMaxServiceEpisodes] = useState(null)
  const [pastServiceEpisodes, setPastServiceEpisodes] = useState(null)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const convertDate = (date) => {
    const parsedDate = DateTime.fromISO(date)
    return parsedDate.toFormat("MM/dd/yyyy")
  }

  const { loading: loadingMaxServiceEpisode } = useQuery(
    GET_MAX_SERVICE_EPISODE,
    {
      variables: {
        participant_id: userCtx.participant_id,
        organization_id: userCtx.session.user.organization_id,
        staff_id: userCtx.session.user.staff_id,
        participant_membership_id: userCtx.participant_membership_id,
      },
      fetchPolicy: "network-only",
      skip: !userCtx.participant_id,
      onCompleted: async (data) => {
        if (data.getMaxServiceEpisode === null) {
          return setMaxServiceEpisodes(null)
        }
        const episodesList = data?.getMaxServiceEpisode || []

        const handleData = _.map(episodesList, (episode) => {
          const viewIntake = episode.episode_code_id === "100"

          const viewDischarge = episode.episode_code_id === "200"

          const editIntake =
            episode.episode_code_id === "100" &&
            userCtx.session.user.staff_role < 6

          const viewServiceRecord = _.includes(
            ["101", "102", "103", "104", "105", "106"],
            episode.episode_code_id
          )

          let actionButton

          if (viewIntake) {
            if (episode?.episode_intake_uid) {
              actionButton = (
                <Button
                  label="View"
                  onClick={() => {
                    navigateWithOrigin(
                      navigate,
                      `/form/view/${episode.template_name}/${episode.episode_intake_uid}`
                    )
                  }}
                />
              )
            } else {
              actionButton = (
                <Button
                  label="View"
                  onClick={() => {
                    navigateWithOrigin(
                      navigate,
                      `/form/view/${episode.template_name}/${episode.manage_services_uid}`
                    )
                  }}
                />
              )
            }
          }

          if (viewServiceRecord) {
            actionButton = (
              <Button
                label="View"
                onClick={() => {
                  navigateWithOrigin(
                    navigate,
                    `/form/view/manage_services/${episode.manage_services_uid}`
                  )
                }}
              />
            )
          }

          if (viewDischarge) {
            actionButton = (
              <Button
                label="View"
                onClick={() => {
                  navigateWithOrigin(
                    navigate,
                    `/form/view/discharge_session/${episode.episode_discharge_uid}`
                  )
                }}
              />
            )
          }

          let date
          if (!_.isNull(episode?.episode_intake_date)) {
            date = episode?.episode_intake_date
          } else if (!_.isNull(episode?.manage_services_date)) {
            date = episode?.manage_services_date
          } else if (!_.isNull(episode?.episode_discharge_date)) {
            date = episode?.episode_discharge_date
          }
          let episode_name = ""
          let detailEpisode = ""
          switch (episode?.episode_code_id) {
            case "100":
              episode_name = "Service Episode Start"
              detailEpisode = "Intake Session"
              break
            case "101":
              episode_name = "Program ID Change"
              detailEpisode = episode?.program_ids
              break
            case "102":
              episode_name = "Staff Assignment Change"
              detailEpisode = episode?.staff_ids
              break
            case "103":
              episode_name = "Location ID Change"
              detailEpisode = episode?.location_ids
              break
            case "104":
              episode_name = "External ID Change"
              detailEpisode = episode?.external_ids
              break
            case "105":
              episode_name = "Share Participant Record"
              break
            case "106":
              episode_name = "Transfer Participant Record"
              break
            case "200":
              episode_name = "Service Episode End"
              detailEpisode = "Discharge Session"
              break

            default:
              break
          }
          return {
            service_episodes_id: episode?.service_episodes_id,
            episode_intake_date: episode?.episode_intake_date,
            manage_services_date: episode?.manage_services_date,
            date: convertDate(date),
            episode_code_id: episode_name,
            program_ids: episode?.program_ids,
            staff_ids: episode?.staff_ids,
            location_ids: episode?.location_ids,
            edit: actionButton,
            detailEpisode: detailEpisode,
          }
        })
        setMaxServiceEpisodes(handleData)
      },
    }
  )

  const { loading: loadingPastServicesEpisode } = useQuery(
    GET_PAST_SERVICE_EPISODE_SUMMARIZED,
    {
      variables: {
        participant_id: userCtx.participant_id,
        organization_id: userCtx.session.user.organization_id,
        staff_id: userCtx.session.user.staff_id,
        participant_membership_id: userCtx.participant_membership_id,
      },
      fetchPolicy: "network-only",
      skip: !userCtx.participant_id,
      onCompleted: async (data) => {
        if (data.getPastServiceEpisodesSummarized === null) {
          setPastServiceEpisodes(null)
        }
        const episodesList = data?.getPastServiceEpisodesSummarized || []

        const handleData = _.map(episodesList, (episode) => {
          /*   const actionButton = (
            <SplitButton
              label="View Intake"
              to={`/form/view/intake_session/${episode.episode_intake_uid}`}
              onClick={() => {
                navigate(
                  `/form/view/intake_session/${episode.episode_intake_uid}`
                )
              }}
              model={[
                {
                  label: "View Discharge",
                  command: () => {
                    navigate(
                      `/form/view/discharge_session/${episode.episode_discharge_uid}`
                    )
                  },
                },
                {
                  label: "View Service Episode",
                  command: () => {
                    navigate(
                      `/participant/manage/service-episode/${episode.service_episodes_id}`
                    )
                  },
                },
              ]}
            />
          )*/

          const actionButton = (
            <Button
              label="View"
              to={`/participant/manage/service-episode/${episode?.episode_number}`}
              onClick={() => {
                navigate(
                  `/participant/manage/service-episode/${episode?.episode_number}`
                )
              }}
            />
          )

          return {
            service_episodes_id: episode?.service_episodes_id,
            episode_intake_date: convertDate(
              episode?.episode_intake_date || episode?.manage_services_date
            ),
            episode_discharge_date: convertDate(
              episode?.episode_discharge_date
            ),
            edit: actionButton,
          }
        })
        setPastServiceEpisodes(handleData)
      },
    }
  )

  const loading = loadingMaxServiceEpisode || loadingPastServicesEpisode

  if (loading) return <LoaderFullPage />

  const handleNewEpisodeBtn =
    _.includes(
      GLOBALS_STATUS.ACTIVE_STATUS,
      userCtx.participant_membership_status
    ) || userCtx.participant_membership_status === "Kiosk Member" ? (
      <Link to="/form/manage_services/1/" className="btn mb-5">
        Manage Service Episode
      </Link>
    ) : null

  const handleEditEpisodeBtn =
    !_.includes(
      GLOBALS_STATUS.ACTIVE_STATUS,
      userCtx.participant_membership_status
    ) && userCtx.participant_membership_status !== "Kiosk Member" ? (
      <Link to="/form/intake_reactivation_session/1/" className="btn mb-5">
        Start New Service Episode
      </Link>
    ) : null

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <ParticipantSidebar />
      </div>
      <div className="main-content">
        <ParticipantProfileBoxSmall />
        <div>
          <div>
            <h1 className={styles.title}>Service Episodes</h1>
            <div className="mb-5">
              <p>
                Service records are generated on a time delay and should be
                available 15 minutes after completion.
              </p>
            </div>

            {handleNewEpisodeBtn}
            {handleEditEpisodeBtn}

            <h2 className={styles.subTitle}>Current Service Episode</h2>

            <DataTable
              value={maxServiceEpisodes}
              responsiveLayout="scroll"
              className="mb-5"
            >
              <Column field="date" header="Service Date" />
              <Column field="episode_code_id" header="Service Type" />
              {/*<Column field="program_ids" header="Program ID Assign" />
              <Column field="staff_ids" header="Staff Assign" />
              <Column field="location_ids" header="Location Assign" />*/}
              <Column field="detailEpisode" header="Service Detail" />
              <Column field="edit" header="Actions" />
            </DataTable>

            <h2 className={styles.subTitle}>Past Service Episodes</h2>
            <DataTable
              value={pastServiceEpisodes}
              responsiveLayout="scroll"
              className="mb-5"
            >
              <Column field="episode_intake_date" header="Intake Date" />
              <Column field="episode_discharge_date" header="Discharge Date" />
              <Column field="edit" header="Actions" />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  )
}
